(() => {
  const init = () => {
    document.querySelectorAll('[data-me-ca-page]').forEach((page) => {
      const reveal = page.querySelectorAll('.me-ca-reveal');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        reveal.forEach((item) => observer.observe(item));
      } else reveal.forEach((item) => item.classList.add('is-visible'));

      const hero = page.querySelector('[data-me-ca-hero]');
      const sticky = page.querySelector('[data-me-ca-sticky]');
      if (hero && sticky && 'IntersectionObserver' in window) {
        const heroObserver = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: 0.05 });
        heroObserver.observe(hero);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
